import { observer } from "mobx-react-lite";
import { useRef, type CSSProperties } from "react";
import { useNavigate } from "react-router-dom";
import { EasyAvatar } from "fin-web-components";
import { RightOutlined, SafetyCertificateOutlined, ShoppingOutlined } from "@ant-design/icons";
import { globalModel } from "../../global/GlobalModel";
import { avatarDisplayWord } from "../../utils/avatarDisplayWord";
import { useSafeAreaTopPad } from "../../utils/useSafeAreaTopPad";
import "./SpaceMineStyle.css";

type Props = {
  spaceId: string;
};

function maskPhone(phone: string | undefined): string {
  const p = phone?.trim() ?? "";
  if (/^\d{11}$/.test(p)) {
    return `${p.slice(0, 3)}****${p.slice(7)}`;
  }
  return p || "未绑定手机";
}

/** 空间「我的」Tab：参考微信「我的」布局 */
export const SpaceMinePage = observer((props: Props) => {
  const { spaceId } = props;
  const navigate = useNavigate();
  const user = globalModel.currentUser;
  const displayName = user?.name?.trim() || "未登录";
  const letter = avatarDisplayWord(displayName) || "·";
  const profileRef = useRef<HTMLButtonElement>(null);
  const safeTopPad = useSafeAreaTopPad(profileRef);

  const goProfile = () => {
    navigate(`/space/${spaceId}/mine/profile`);
  };

  const goBenefits = () => {
    navigate(`/space/${spaceId}/mine/benefits`);
  };

  const goOrders = () => {
    navigate(`/space/${spaceId}/mine/orders`);
  };

  return (
    <div className="space-mine-page">
      <button
        ref={profileRef}
        type="button"
        className="space-mine-profile"
        style={
          safeTopPad > 0
            ? ({ "--space-mine-profile-safe-top-pad": `${safeTopPad}px` } as CSSProperties)
            : undefined
        }
        onClick={goProfile}
      >
        <EasyAvatar
          shape="circle"
          size={64}
          url={user?.avatarUrl}
          word={letter}
          alt=""
          className="space-mine-profile__avatar"
        />
        <div className="space-mine-profile__info">
          <p className="space-mine-profile__name">{displayName}</p>
          <p className="space-mine-profile__phone">{maskPhone(user?.phone)}</p>
        </div>
        <RightOutlined className="space-mine-profile__arrow" />
      </button>

      <section className="space-mine-menu" aria-label="账户服务">
        <button type="button" className="space-mine-menu__item" onClick={goBenefits}>
          <SafetyCertificateOutlined
            className="space-mine-menu__icon space-mine-menu__icon--benefits"
            aria-hidden
          />
          <span className="space-mine-menu__label">我的权益</span>
          <RightOutlined className="space-mine-menu__arrow" aria-hidden />
        </button>
        <button type="button" className="space-mine-menu__item" onClick={goOrders}>
          <ShoppingOutlined
            className="space-mine-menu__icon space-mine-menu__icon--orders"
            aria-hidden
          />
          <span className="space-mine-menu__label">我的订单</span>
          <RightOutlined className="space-mine-menu__arrow" aria-hidden />
        </button>
      </section>
    </div>
  );
});

export default SpaceMinePage;
